// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2ON79","flex":"Banner_flex__8RJJk","title":"Banner_title__1Xfnt","paragraph":"Banner_paragraph__2HtX9","link":"Banner_link__1mjFT"};